import React from 'react'
import { useTemplateSelectOptions } from '@ztechapps/common.hook'
import type { SelectInlineInputProps, SelectOption } from '@ztechapps/webui.input'
import { SelectInlineInput } from '@ztechapps/webui.input'
import { TemplateSelectCreatable } from './TemplateSelect'
import type { TemplateSelectCreatableProps } from './TemplateSelect'
import type { TemplateSelectProps } from './index'

export type TemplateSelectInlineInputProps = SelectInlineInputProps<Omit<TemplateSelectProps, 'templateCategory'>> &
  Pick<TemplateSelectCreatableProps, 'templateCategory'>
export const TemplateSelectInlineInput = ({
  inputProps,
  isMulti,
  templateCategory,
  selectComponent,
  ...props
}: TemplateSelectInlineInputProps) => {
  const options = useTemplateSelectOptions<SelectOption>({
    filter: inputProps?.filter,
    templateCategory: templateCategory,
  })

  return (
    <SelectInlineInput<TemplateSelectProps>
      selectOptions={options}
      selectComponent={selectComponent ?? TemplateSelectCreatable}
      isMulti={isMulti}
      inputProps={{ ...inputProps, isMulti, templateCategory }}
      {...props}
    />
  )
}
